(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["he-trustedtv-tag"] && !Shopify.designMode) return;
  try {
    
(function () {
  var trustedTvScript = document.createElement("script");
  trustedTvScript.async = true;
  trustedTvScript.src = "https://p3.trustedtv.com/5f4396f5-4879-45e9-a6c5-d5f6b6c3fca5.js";

  document.head.appendChild(trustedTvScript);
})();

  } catch(e) { console.error(e); }
})();
})();
